import { dependentKeyCompat } from '@ember/object/compat';
import type OptionsService from '@linc-technologies/linced-common/services/options';

// OptionsHost is any object with the `options` service injected.
interface OptionsHost {
  options: OptionsService;
}

// SchoolHost is a school record. option reads a school option from the
// school dynamic fields.
interface SchoolHost {
  option(key: string): unknown;
}

// TypeScript types a field decorator as returning void. Ember legacy
// decorators return the descriptor, so the functions below are cast.

// optionAlias gives a prop that reads a school option for the session school
// (or its default) via the `options` service. The prop is autotracked, and
// classic computed properties can use it as a dependent key.
// !!!you need to import the options service wherever you call optionsAlias!!!
// Use it as a decorator only. In a classic object (EmberObject.extend or a
// mixin), use `dependentKeyCompat({ get() { return this.options.value(key); } })`.
export function optionAlias(key: string): PropertyDecorator {
  return function (target: object, prop: string): PropertyDescriptor {
    return dependentKeyCompat(target, prop, {
      configurable: true,
      enumerable: true,
      get(this: OptionsHost): unknown {
        return this.options.value(key);
      },
    });
  } as unknown as PropertyDecorator;
}

// schoolOptionAlias is similar to optionAlias, but for use on a School model
// directly (i.e. not via the `options` service).
export function schoolOptionAlias(key: string): PropertyDecorator {
  return function (target: object, prop: string): PropertyDescriptor {
    return dependentKeyCompat(target, prop, {
      configurable: true,
      enumerable: true,
      get(this: SchoolHost): unknown {
        return this.option(key);
      },
    });
  } as unknown as PropertyDecorator;
}
